module.exports = __webpack_public_path__ + "img/ring.145140f0.png";